export default {
  'editorial-staff': 'La nostra redazione',
  'published-on': 'Pubblicato il',
  'read-articles': 'Leggi i suoi articoli',
  'about-author': "Riguardo l'autore",
}
